import React from 'react';
import PropTypes, { string } from 'prop-types';
import { Separator, Title } from '@common/components';
import sidebarSection from './SidebarSection.module.scss';

export default function SidebarSection({ title, children }) {
  return (
    <div>
      <Title type="h2" color="grey-300" className={sidebarSection.sectionTitle}>
        {title}
      </Title>
      <Separator className={sidebarSection.separator} color="secondary" />
      {children}
    </div>
  );
}

SidebarSection.propTypes = {
  title: string,
  children: PropTypes.node,
};
